import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Trash2 } from "lucide-react";
import { api, type ExcludedIp } from "../lib/api";
import { Card } from "./ui";

export function ExcludedIpsCard() {
  const queryClient = useQueryClient();
  const ips = useQuery({
    queryKey: ["admin-ips"],
    queryFn: () => api.get<{ ips: ExcludedIp[] }>("/api/admin-ips"),
  });

  const remove = useMutation({
    mutationFn: (ip: string) => api.del(`/api/admin-ips/${encodeURIComponent(ip)}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admin-ips"] }),
  });

  const list = ips.data?.ips ?? [];

  return (
    <Card title="IP admin yang dikecualikan">
      <p className="mb-2 text-xs text-slate-500">
        Kunjungan dari IP yang dipakai untuk masuk atau membuka dasbor ini tidak ikut tercatat. Entri kedaluwarsa
        otomatis setelah 7 hari tidak dipakai.
      </p>
      {ips.isLoading ? (
        <p className="text-sm text-slate-500">Memuat...</p>
      ) : list.length === 0 ? (
        <p className="text-sm text-slate-500">Belum ada IP tercatat.</p>
      ) : (
        <ul className="divide-y divide-slate-100">
          {list.map((row) => (
            <li key={row.ip} className="flex items-center justify-between gap-3 py-2">
              <div className="min-w-0">
                <p className="truncate font-mono text-xs text-slate-700">{row.ip}</p>
                <p className="text-[11px] text-slate-400">
                  Terakhir dipakai{" "}
                  {new Intl.DateTimeFormat("id-ID", { dateStyle: "medium", timeStyle: "short" }).format(
                    new Date(row.last_seen),
                  )}
                </p>
              </div>
              <button
                type="button"
                className="btn-danger px-2 py-1 text-xs"
                title="Catat kembali kunjungan dari IP ini"
                disabled={remove.isPending}
                onClick={() => remove.mutate(row.ip)}
              >
                <Trash2 size={14} />
              </button>
            </li>
          ))}
        </ul>
      )}
      {remove.error && <p className="mt-2 text-sm text-red-600">{(remove.error as Error).message}</p>}
    </Card>
  );
}
